export const BaseURL = process.env.REACT_APP_API_BASE_URL;
export const ContestToken = 'waenoh4Aa3quao7ceigohnohp9eec7Teebeizae4aing9nee9xi7yei3ahchee9U';

export const isMock = () => {
    return (window as any)?.NaviScripts?.isBuild;
};
